
define('unknown/models/recoverModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var Recover = Backbone.Model.extend({
		urlRoot:"/draftapp/users/recover",
		defaults: {
	    	email: null
	    },

	    initialize: function() {
	    	
	    },
	});
	
	
	return Recover;  
});